document.addEventListener('click', function (e) {
  const qtyBtn = e.target.closest('.card-ajax-atc__qty-btn');
  const addBtn = e.target.closest('.card-ajax-atc__btn');

  if (qtyBtn) {
    e.preventDefault();
    e.stopPropagation();
    const wrap = qtyBtn.closest('.card-ajax-atc');
    const numEl = wrap.querySelector('.card-ajax-atc__qty-num');
    let qty = parseInt(numEl.textContent, 10) || 1;
    if (qtyBtn.dataset.action === 'plus') qty = Math.min(qty + 1, 99);
    if (qtyBtn.dataset.action === 'minus') qty = Math.max(qty - 1, 1);
    numEl.textContent = qty;
    return;
  }

  if (addBtn) {
    e.preventDefault();
    e.stopPropagation();

    if (addBtn.classList.contains('is-loading') || addBtn.classList.contains('is-added')) return;

    const wrap = addBtn.closest('.card-ajax-atc');
    const variantId = wrap.dataset.variantId;
    const qty = parseInt(wrap.querySelector('.card-ajax-atc__qty-num').textContent, 10) || 1;

    addBtn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty }),
    })
      .then((r) => {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(() => {
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-added');

        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            document.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
            );
            document.querySelectorAll('[data-cart-count]').forEach((el) => {
              el.textContent = cart.item_count;
            });
          })
          .catch(() => {});

        setTimeout(() => {
          addBtn.classList.remove('is-added');
        }, 900);
      })
      .catch(() => {
        addBtn.classList.remove('is-loading');
      });
  }
});